import styled from '@emotion/styled';

import { Col } from 'antd';

export const StyledRoomTypeCardTitle = styled(Col)`
  font-size: 20px;
  font-weight: bold;
  word-wrap: break-word;
`;
